import PropTypes from 'prop-types'
import React, { Component } from 'react'

import Icon from '../../shared/components/Icon'

import PaneWrapper from './PaneWrapper'
import List from './SimpleList'

export default class Pane extends Component {

  static propTypes = {
    data: PropTypes.object,
    onLoad: PropTypes.func
  }

  render() {
    const { data } = this.props

    return (
      <PaneWrapper>

        <h1 className="with-tools">
          Programme
          <span className="tools">
            <button
              className="btn btn-sm btn-default"
              onClick={this.props.onLoad}
            >
              Aktualisieren
            </button>
          </span>
        </h1>

        <div className="toolbar">
          <span className="tools">
            <a href="/program/create">
              <Icon
                className="tool-icon"
                size={18}
                name="plus-turquoise"
              />
              Neues Programm
            </a>
          </span>
        </div>

        <div className="vertical v-scrollable pane-list-container">
          <List
            filter={{ isDeactivated: false }}
            program={data}
          />
          <h5>Deaktivierte Programme</h5>
          <List
            filter={{ isDeactivated: true }}
            program={data}
          />
        </div>

      </PaneWrapper>
    )
  }

}



// WEBPACK FOOTER //
// ./src/program/components/Pane.js